import * as tslib_1 from "tslib";
import { BaseApiClient } from './BaseApiClient';
export var LEAGUES_ENDPOINTS = {
    BY_SPORT_ID: '/api/v1/Leagues/GetBySportId',
    TOP_LEAGUES_BY_SPORT_ID: '/api/v1/Leagues/GetTopLeaguesBySportId'
};
/**
 * LeaguesApiClient - client for fetching Leagues BFF endpoints
 * @export
 * @class LeaguesApiClient
 * @extends {BaseApiClient}
 */
var LeaguesApiClient = /** @class */ (function (_super) {
    tslib_1.__extends(LeaguesApiClient, _super);
    function LeaguesApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch all leagues by sport id from BFF
     * @param {request} LeaguesBySportIdRequest
     * @throws {RequiredError}
     * @memberof LeaguesApiClient
     */
    LeaguesApiClient.prototype.getBySportId = function (request) {
        return this.executeRequest(LEAGUES_ENDPOINTS.BY_SPORT_ID, request);
    };
    /**
     * Fetch all top leagues by sport id from BFF
     * @param {request} TopLeaguesBySportIdRequest
     * @throws {RequiredError}
     * @memberof LeaguesApiClient
     */
    LeaguesApiClient.prototype.getTopLeaguesBySportId = function (request) {
        return this.executeRequest(LEAGUES_ENDPOINTS.TOP_LEAGUES_BY_SPORT_ID, request);
    };
    return LeaguesApiClient;
}(BaseApiClient));
export { LeaguesApiClient };
//# sourceMappingURL=LeaguesApiClient.js.map